var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBluetooth(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 24,
    viewBox: "0 0 16 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.77295 20.401V13.4298L11.8192 16.6069C12.0698 16.8696 12.0608 17.2864 11.797 17.536L8.77295 20.401ZM11.9188 7.14108L8.77295 10.1722V3.48584L11.8916 6.17367C12.1906 6.43238 12.2027 6.86727 11.9188 7.14108ZM10.1491 11.3863L14.8131 6.90655C14.9641 6.76159 14.9621 6.52704 14.809 6.38409L7.97673 0.185979C7.5197 -0.228772 6.78684 0.0953782 6.78684 0.712471V9.58834L1.77358 4.55395C1.50379 4.28315 1.06086 4.28315 0.791068 4.55294L0.193102 5.15192C-0.0696412 5.41466 -0.0636011 5.83746 0.207195 6.09215L5.8315 11.3853C6.11035 11.648 6.11035 12.0768 5.8315 12.3396L0.207195 17.6327C-0.0636011 17.8874 -0.0696412 18.3102 0.193102 18.5729L0.791068 19.1709C1.06086 19.4417 1.50379 19.4417 1.77358 19.1699L6.78684 14.1365V23.1422C6.78684 23.711 7.4603 24.01 7.88311 23.6305L14.8886 17.3236C15.0416 17.1797 15.0416 16.9441 14.8886 16.8002L10.1532 12.3346C9.87834 12.0748 9.87633 11.648 10.1491 11.3863Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBluetooth);
export default __webpack_public_path__ + "static/media/bluetooth.4e69627b.svg";
export { ForwardRef as ReactComponent };